import { remove } from "lodash";

const key = "entity-security-allow-all";

const applicable = (resp) => {
	return resp.config.url.match(/api\/forms\/[0-9]+\/security$/);
};

const modify = (resp) => {
	if(resp.data.Success !== true || !resp.data.Data) {
		return;
	}
	
	const assigned = resp.data.Data.Assigned;
	const role = resp.data.Data.Roles.find(r => r.Code === assigned[0].Code);

	remove(role.Actions, a => a.Path === "/types/**/*");

	const allowCreateDealer = { Effect: "Allow", Path: "/types/DEALER/write" };
	role.Actions.push(allowCreateDealer);

	const allowManageIdentifiers = { Effect: "Allow", Path: "/types/DEALER/identifiers/*/read" };
	role.Actions.push(allowManageIdentifiers);

	const allowManageIdentifiers2 = { Effect: "Deny", Path: "/types/DEALER/identifiers/GARFO/read" };
	role.Actions.push(allowManageIdentifiers2);

	const allowAddIdentifiers = { Effect: "Allow", Path: "/types/DEALER/identifiers/*/create" };
	role.Actions.push(allowAddIdentifiers);

	const allowAllUpdateIdentifiers = { Effect: "Allow", Path: "/types/DEALER/identifiers/*/update" };
	role.Actions.push(allowAllUpdateIdentifiers);

	const allowDeactivateIdentifiers = { Effect: "Allow", Path: "/types/DEALER/identifiers/*/deactivate" };
	role.Actions.push(allowDeactivateIdentifiers);

	const allowReactivateIdentifiers = { Effect: "Allow", Path: "/types/DEALER/identifiers/*/reactivate" };
	role.Actions.push(allowReactivateIdentifiers);


	const allowEditHarvester = { Effect: "Allow", Path: "/types/FISHERMAN/write" };
	role.Actions.push(allowEditHarvester);
	
	const allowManageClassifications = { Effect: "Allow", Path: "/types/FISHERMAN/classifications/*/read" };
	role.Actions.push(allowManageClassifications);

	const allowAddClassifications = { Effect: "Allow", Path: "/types/FISHERMAN/classifications/*/add" };
	role.Actions.push(allowAddClassifications);

	const allowDeactivateClassifications = { Effect: "Allow", Path: "/types/FISHERMAN/classifications/*/remove" };
	role.Actions.push(allowDeactivateClassifications);

	
	const allowEditDealerLicense = { Effect: "Allow", Path: "/types/DEALER_LICENSE/write" };
	role.Actions.push(allowEditDealerLicense);

	const allowReadEffective = { Effect: "Allow", Path: "/types/DEALER_LICENSE/effective/*/read" };
	role.Actions.push(allowReadEffective);

	// const allowAddEffective = { Effect: "Deny", Path: "/types/DEALER_LICENSE/effective/*/create" };
	// role.Actions.push(allowAddEffective);

	const allowUpdateEffective = { Effect: "Allow", Path: "/types/DEALER_LICENSE/effective/PAUL/update" };
	role.Actions.push(allowUpdateEffective);

	const allowDeactivateEffective = { Effect: "Allow", Path: "/types/DEALER_LICENSE/effective/JAMES/delete" };
	role.Actions.push(allowDeactivateEffective);

	const denySpecificScope = { Effect: "Allow", Path: "/types/DEALER_LICENSE/effective/JAMES/create" };
	role.Actions.push(denySpecificScope);

	
	const allowEditVessel = { Effect: "Allow", Path: "/types/VESSEL/write" };
	role.Actions.push(allowEditVessel);
	
	const allowManageContacts = { Effect: "Allow", Path: "/types/VESSEL/contacts/*/read" };
	role.Actions.push(allowManageContacts);

	const allowAddContacts = { Effect: "Allow", Path: "/types/VESSEL/contacts/*/create" };
	role.Actions.push(allowAddContacts);

	const allowUpdateContacts = { Effect: "Allow", Path: "/types/VESSEL/contacts/*/update" };
	role.Actions.push(allowUpdateContacts);

	const allowDeactivateContacts = { Effect: "Allow", Path: "/types/VESSEL/contacts/PAUL/deactivate" };
	role.Actions.push(allowDeactivateContacts);

	const allowReactivateContacts = { Effect: "Allow", Path: "/types/VESSEL/contacts/CAPTAIN/reactivate" };
	role.Actions.push(allowReactivateContacts);

	const allowManageRelationships = { Effect: "Deny", Path: "/types/DEALER/related/*/read" };
	role.Actions.push(allowManageRelationships);
};

export const entitySecurityAllowAll = [key, applicable, modify];